export const locale = {
    lang: 'en',
    data: {
      'EDITOR': {
        'CARGANDO': 'Loading information',
        'GUARDANDO': 'Saving changes',
        'ELEMENTOS': {
          'GUIA': 'Elements of this block',
          'COLORES': {
            'ORIGINAL': 'Unmodified element',
            'MODIFICADO': 'Modified item'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'No element has been modified',
            'MODIFICADO': 'One or more items have been modified',
            'COMPLETO': 'All elements have been modified',
            'AMPLIAR': 'View in large size',
            'ELIMINAR': 'Delete this image',
            'IMPORTAR': 'Import this item from another language',
            'CONFIGDOMINIO': 'Backend domain configuration',
            'COPIARURL': 'Copy link'
          },
          'ETIQUETAS': {
            'INTERFAZ': {
              'TITULO': 'Configuration by broker',
              'SUBTITULO': 'You can view and modify the settings of each available broker',
              'PASOINICIAL': 'Select a broker from the list to show its configuration',
              'SELBROKER': 'Selected broker',
              'SELOPC': 'Selected option',
              'SINJSONS': 'Failed to load information from this broker, please try later ',
              'DOMINIO': {
                'TITULO': 'Broker backend domain configuration',
                'ACTIVAR': 'Activate domain associated with the broker',
                'DOMINIO': 'Domain associated with the broker'
              },
              'MODAL': {
                'TITULO': 'Import element',
                'SUBTITULO': 'Select the language you want to import this item from'
              }
            },
            'IMAGEN': {
              'NOHAY': 'There is no image',
              'ACTUAL': 'Current image'
            },
            'TEXTO': {
              'INGRESAR': 'Enter your text'
            },
            'VIDEO': {
              'NOVIDEO': 'You have not uploaded a video',
              'GUARDANDO': 'Saving video, do not exit this screen until upload is complete'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Edit survey characteristics',
            'REGRESAR': 'Go back',
            'CONTINUAR': 'Continue',
            'CANCELAR': 'Cancel',
            'GUARDAR': 'Save Changes',
            'IMAGEN': 'Change image',
            'EDITOR': 'Edit message',
            'ELEMENTOS': 'Help',
            'ACTIVAR': 'Show',
            'DESACTIVAR': 'Hide',
            'VERVIDEO': 'Watch video',
            'CARGARVIDEO': 'Upload video file',
            'OTROVIDEO': 'Upload another video file',
            'SI': 'Yes',
            'NO': 'No',
            'INFO': 'Important',
            'ADDIMG': 'Add Image'
          },
          'MODALIMAGEN': {
            'TITULO': 'Add image to message',
            'TABS': {
              'INSTRUCCIONES': {
                'TITULO': 'Instructions',
                'PASO_1': 'Click the \'Images\' tab, there you can choose an already uploaded image, or you can also upload a new image',
                'PASO_2': 'If you want to choose an image already uploaded, by placing the cursor on the desired image you can perform two actions: View the image or copy the link',
                'PASO_2_1': 'To preview, click the button to the button on the image with the following icon',
                'PASO_2_2': 'To copy the link, click on the button to the button on the image with the following icon',
                'PASO_3': 'If you want to upload a new image, click the button with the following icon',
                'PASO_4': 'When you finish uploading the image, you will automatically get its link',
                'PASO_5': 'Go back to the message editor and click the button to insert an image, with the following icon',
                'PASO_6': 'In the pop-up window place the copied link and set the image size, expressed in pixels. When finished, click the Save button. The pop-up window will close and the image will be placed in the editor with the set size'
              },
              'IMAGENES': {
                'TITULO': 'Images',
                'CARGANDO': 'Loading available images',
                'NOTA': '* The images shown here are saved in the file manager',
                'TITULO_2': 'Available images',
                'ADD': 'Add a new image',
                'NOIMG': 'No images available',
                'URLCOPIADA': 'Image link copied to clipboard',
                'OKBOT': 'Ok'
              },
            }
          }
        },
        'CATALOGOS': {
          'temas': {
            'temaFocusArea2': 'Color set 1',
            'theme-temaIzzi': 'Color set 2',
            'theme-blue-gray-dark': 'Color set 3',
            'theme-pink-dark': 'Color set 4',
            'theme-temaIzzi-2': 'Color set 5',
            'theme-temaItbm': 'Color set 6',
          },
          'numColumnas': {
            '1': '1 column',
            '4': '4 columns',
            '5': '5 columns',
          },
          'segundos': {
            '1000': '1 second',
            '2000': '2 seconds',
            '3000': '3 seconds',
            '4000': '4 seconds',
            '5000': '5 seconds',
            '6000': '6 seconds',
            '7000': '7 seconds',
            '8000': '8 seconds',
            '9000': '9 seconds',
            '10000': '10 seconds',
            '11000': '11 seconds',
            '12000': '12 seconds',
            '13000': '13 seconds',
            '14000': '14 seconds',
            '15000': '15 seconds',
            '16000': '16 seconds',
            '17000': '17 seconds',
            '18000': '18 seconds',
            '19000': '19 seconds',
            '20000': '20 seconds',
          },
          'logosIniciales': {
            '0': 'CulturalGO logo'
          }
        },
        'ADVERTENCIAS': {
          'URLEXTERNA': 'Warning: If the source site does not allow access to the page from external sites, the content will not be displayed',
          'TEMPLATEFALTANTE': 'Warning: This template is not available for this language',
          'CONFIGURACION': {
            'ACTIVAR': 'Caution: When activating the custom configuration, all the items specified on this screen will be placed in the platform interface, make sure you have placed all the correct items \n\n Do you want to continue and activate the custom configuration?',
            'DESACTIVAR': 'Caution: When deactivating the custom configuration, the default elements established in the platform for this broker and for all the users belonging to it will be placed. \n\n Do you want to continue and deactivate the personalized configuration?'
          },
          'PRIORIDAD': {
            '1': 'If this element is active, priority will be given over the background images',
            '2': 'If this element is active, priority will be given over the background images and the video background.'
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Login',
            'PASOS': {
              'VARIOS': {
                'TITULO': 'Miscellaneous items',
                'ELEMENTOS': {
                  'images_broker': 'Broker logo',
                  'title': 'Main title',
                  'images_login': 'System logo',
                  'images_logout': 'Image displayed when logging out',
                  'changeTime': 'Time interval between images'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Background images',
                'ELEMENTOS': {
                  'agregar': 'Add an image',
                  'importar': 'Import images from other settings',
                }
              },
              'VIDEO': {
                'TITULO': 'Background video',
                'ELEMENTOS': {
                  'enable': 'Enable background video',
                  'video': 'Video to show',
                  'loop': 'Enable auto repeat',
                  'mute': 'Show muted video'
                }
              },
              'EXTERNO': {
                'TITULO': 'External content',
                'ELEMENTOS': {
                  'enable': 'Enable external content',
                  'url': 'Link of external content to display',
                }
              }
            }
          },
          'HOME': {
            'TITULO': 'Home page',
            'PASOS': {
              'BRAND':{
                'TITULO': 'System identity in the side menu',
                'ELEMENTOS': {
                  'logo': 'System logo',
                  'name': 'System name'
                }
              },
              'LOGOINICIAL': {
                'TITULO': 'Initial logo',
                'ELEMENTOS': {
                  'show': 'Show initial system logo',
                  'time': 'Logo display time (expressed in seconds)',
                  'type': 'Initial logo type to display'
                }
              },
              'MOSAICO': {
                'TITULO': 'Mosaic of images',
                'ELEMENTOS': {
                  'branding_show': 'Show system brand logo',
                  'branding_image': 'System brand logo',
                  'grayFilter': 'Gray filter on startup images',
                  'bgGridColumns': 'Number of columns of images to display'
                }
              },
              'TEMAS': {
                'TITULO': 'Platform color theme',
                'ELEMENTOS': {
                  'theme': 'Color theme to display in the system'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Background images',
                'ELEMENTOS': {
                  'agregar': 'Add an image',
                  'importar': 'Import images from other settings',
                }
              },
              'VIDEO': {
                'TITULO': 'Background video',
                'ELEMENTOS': {
                  'enable': 'Enable background video',
                  'video': 'Video to show',
                  'loop': 'Enable auto repeat',
                  'mute': 'Show muted video'
                }
              },
              'EXTERNO': {
                'TITULO': 'External content',
                'ELEMENTOS': {
                  'enable': 'Enable external content',
                  'url': 'Link of external content to display',
                }
              },
              'LOADER': {
                'TITULO': 'Image .gif loading',
                'ELEMENTOS': {
                  'image': 'Image loading .gif',
                  'GUARDANDO': 'Saving image, do not exit this screen until loading is complete'
                }
              },
            }
          },
          'TEMPLATES': {
            'TITULO': 'Email templates',
            'PASOS': {
              'RT_1': {
                'TITULO': 'Technical requirements, sent when registering a new product',
                'ELEMENTOS': {
                  'asunto': 'Message Subject',
                  'mensaje': 'Message body'
                }
              },
              'RT_2': {
                'TITULO': 'Technical requirements, demo message sent during validation',
                'ELEMENTOS': {
                  'asunto': 'Message Subject',
                  'mensaje': 'Message body'
                }
              },
              'PASS_3': {
                'TITULO': 'Mail sent when updating user password',
                'ELEMENTOS': {
                  'asunto': 'Message Subject',
                  'mensaje': 'Message body'
                }
              },
              'PASS_4': {
                'TITULO': 'Email sent when updating user profile',
                'ELEMENTOS': {
                  'asunto': 'Message Subject',
                  'mensaje': 'Message body'
                }
              },
              'GETMYCODE_6': {
                'TITULO': 'Mail sent with GetMyCode',
                'ELEMENTOS': {
                  'asunto': 'Message Subject',
                  'mensaje': 'Message body'
                }
              },
              'RT_7': {
                'TITULO': 'Mail for acceptance of technical requirements',
                'ELEMENTOS': {
                  'asunto': 'Message Subject',
                  'mensaje': 'Message body'
                }
              },
            }
          }
        }
      }
    }
};
